import { createContext } from "react"
import styles from "./styles.module.scss"
import cn from "clsx"
import { Background } from "./Background"
import { Loader } from "./Loader"
import type { FC, HTMLAttributes } from "react"


interface ContainerProps
extends HTMLAttributes<HTMLDivElement> {}

export const Container: FC<ContainerProps> = ({ children, className, ...rest }) => (
  <main {...rest} className={cn(styles.container, className)}>
    <Background />
    <div className={styles.forward}>
      {children}
    </div>
    <Loader />
  </main>
)

export const Context = createContext<any>({})
